
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/dhi-overview",
      function () {
        return require("private-next-pages/archive/dhi-overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/dhi-overview"])
      });
    }
  